import { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../../config';

import TextField from '@mui/material/TextField';
import '../../styles/global.css';
import '../../styles/buttons.css';
import '../../styles/popup.css';

const EditUserForm = ({ user, roleId, onClose, onUserUpdated }) => {
  const [formData, setFormData] = useState({
    givenName: '',
    middleName: '',
    lastName: '',
    email: '',
    mobileNumber: ''
  });
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log('Role ID:', roleId);
  }, [user, roleId]);

  useEffect(() => {
    if (user) {
      setFormData({
        givenName: user.givenName || '',
        middleName: user.middleName || '',
        lastName: user.lastName || '',
        email: user.email || '',
        mobileNumber: user.mobileNumber || ''
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      const response = await axios.put(
        `${config.API_URL}/v2/role/propertyRole/${roleId}`,
        formData,
        {headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}}
      );
      console.log('Update response:', response);
      if (response.status === 200 || response.status === 201) {
        onUserUpdated?.(response.data);
        onClose();
      } else {
        setError('Failed to update user profile.');
      }
    } catch (err) {
      console.error('Error updating user:', err);
      setError('An error occurred during update.');
    }
  };

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <button className="close-popup" onClick={onClose}>
          <i className="fas fa-times"></i>
        </button>
        <h2 className="text-2xl text-black">Edit User Information</h2>

        <TextField label="First Name" name="givenName" value={formData.givenName} onChange={handleChange} fullWidth sx={{ marginBottom: '1rem' }} />
        <TextField label="Middle Name" name="middleName" value={formData.middleName} onChange={handleChange} fullWidth sx={{ marginBottom: '1rem' }} />
        <TextField label="Last Name" name="lastName" value={formData.lastName} onChange={handleChange} fullWidth sx={{ marginBottom: '1rem' }} />
        <TextField label="Email" name="email" type="email" value={formData.email} onChange={handleChange} fullWidth sx={{ marginBottom: '1rem' }} />
        <TextField label="Mobile Number" name="mobileNumber" value={formData.mobileNumber} onChange={handleChange} fullWidth sx={{ marginBottom: '1rem' }} />

        <button className="button" onClick={handleSubmit}>Update</button>
        {error && <div className="error-message">{error}</div>}
      </div>
    </div>
  );
};

export default EditUserForm;
